import styled from 'styled-components';

export const FormBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 4px;
  flex-grow: 1;

  .input-field {
    background-color: #fff;
  }

  .react-tel-input input {
    padding: 10px 12px 10px 52px;
    border: 1px solid #000 !important;
    box-shadow: none !important;
    width: 100%;
  }
`;
